module.exports = __webpack_public_path__ + "static/media/centro-estetico.b5fc6037.svg";